import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private _authToken: string;

    constructor(authService: AuthService) {
        authService.credential$.subscribe(credential => {
            if (!credential) {
                this._authToken = null;
            } else {
                const token = `${credential.keyId}:${credential.secret}`;
                this._authToken = btoa(token);
            }
        })
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        // bypass authorization head update if already exist
        if (req.headers.get('authorization')) {
            return next.handle(req);
        }

        // bypass external requests
        if (!req.url.startsWith('/')) {
            return next.handle(req);
        }

        const authReq = req.clone({
            setHeaders: {
                'authorization': `basic ${this._authToken}`
            }
        });

        return next.handle(authReq);
    }

}
